import { render, staticRenderFns } from "./SingleSignOnConfiguration.vue?vue&type=template&id=5313c6f9&scoped=true&"
import script from "./SingleSignOnConfiguration.vue?vue&type=script&lang=ts&"
export * from "./SingleSignOnConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313c6f9",
  null
  
)

export default component.exports